const _ = (data: any) => {
  return [
    {
      name: data.productNumber,
      id: data.productNumber,
      price: data.price || data.partnerPrice,
      brand: data.manufacturerCode
    }
  ];
};

export default (data: any, event: string) => {
  const dataLayerObject = _(data);
  return {
    event,
    ecommerce: {
      detail: {
        actionField: {
          list: localStorage.getItem('listName') || 'Product URL/Link'
        },
        products: [...dataLayerObject]
      }
    }
  };
};
